export const Svg_130 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M7.779 50.555h14.048a20.822 20.822 0 0 1-3.293-3.5 19.482 19.482 0 0 1-2.418-4.278H7.779v7.778Zm27.212 0c4.3 0 7.97-1.516 11.008-4.547 3.038-3.031 4.557-6.697 4.557-10.998 0-4.301-1.515-7.97-4.546-11.009-3.032-3.038-6.698-4.557-10.999-4.557-4.3 0-7.97 1.516-11.008 4.547-3.039 3.031-4.558 6.697-4.558 10.998 0 4.301 1.516 7.97 4.547 11.009 3.032 3.038 6.698 4.557 10.999 4.557Zm18.895-23.333h8.337v-7.778H48.175a20.822 20.822 0 0 1 3.293 3.5 19.476 19.476 0 0 1 2.418 4.278ZM2.918 58.332V35h4.86v2.917h7.025a9.906 9.906 0 0 1-.182-1.422c-.025-.462-.037-.96-.037-1.495 0-5.687 1.981-10.512 5.943-14.473 3.962-3.962 8.786-5.943 14.474-5.943h27.222v-2.917h4.861V35h-4.86v-2.916h-7.025c.097.486.158.96.182 1.422.024.462.037.96.037 1.494 0 5.688-1.981 10.513-5.943 14.474-3.962 3.962-8.787 5.943-14.474 5.943H7.779v2.917H2.918Zm32.079-15.36c-1.472 0-2.73-.524-3.776-1.571-1.045-1.047-1.567-2.306-1.567-3.777 0-1.117.19-2.118.57-3.001.382-.883 1.18-2.248 2.395-4.096l2.382-3.5 2.382 3.5c1.215 1.848 2.013 3.213 2.394 4.096.38.883.571 1.884.571 3.002 0 1.47-.524 2.729-1.572 3.776-1.048 1.047-2.308 1.57-3.78 1.57Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={17.756}
        x2={36.29}
        y1={18.666}
        y2={59.909}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)